/* SYFFER — theme.js (vanilla) */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- header: search, mobile nav ---------- */
  function toggle(btn, panel) {
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      if (!open) { var i = $('input', panel); if (i) i.focus(); }
    });
  }
  function initHeader() {
    toggle($('[data-nav-toggle]'), $('#MobileNav'));
    var sb = $('[data-search-toggle]'), sp = $('#SearchBar');
    toggle(sb, sp);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (sp && !sp.hidden) { sp.hidden = true; sb.setAttribute('aria-expanded', 'false'); }
      closeDrawer();
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#CartDrawer');
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; }, 350);
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + n + ')'; el.hidden = !n; });
  }
  function refreshCart() {
    return fetch(T.routes.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var parse = function (html) { return new DOMParser().parseFromString(html, 'text/html'); };
      if (data['cart-drawer']) {
        var d = parse(data['cart-drawer']).querySelector('[data-cart-inner]');
        var cur = drawer && drawer.querySelector('[data-cart-inner]');
        if (d && cur) cur.innerHTML = d.innerHTML;
      }
      var page = $('[data-cart-page]');
      if (page) {
        // cart page: reload the section from the page itself
        return fetch(T.routes.cart + '?view=').then(function (r) { return r.text(); }).then(function (html) {
          var n = parse(html).querySelector('[data-cart-page]');
          if (n) page.innerHTML = n.innerHTML;
        });
      }
    }).then(function () { return fetch(T.routes.cartJs).then(function (r) { return r.json(); }); })
      .then(function (cart) { updateCount(cart.item_count); return cart; });
  }
  function changeLine(line, qty) {
    return fetch(T.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }
  function initCart() {
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-cart-open]');
      if (open && T.cartType === 'drawer' && drawer) { e.preventDefault(); refreshCart().then(openDrawer); return; }
      if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
      var q = e.target.closest('[data-qty-change]');
      if (q) { e.preventDefault(); changeLine(q.getAttribute('data-line'), q.getAttribute('data-qty-change')); }
    });
  }

  /* ---------- product page ---------- */
  function money(cents) {
    var fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: fmt, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(0); }
  }
  function initProduct(sec) {
    var jsonEl = $('[data-product-json]', sec);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', sec);
    var idInput = $('[data-variant-id]', sec);
    var addBtn = $('[data-add-btn]', sec);
    var addLabel = $('[data-add-label]', sec);
    var errEl = $('[data-form-error]', sec);
    var slides = $$('.pdp__slide', sec), thumbs = $$('.pdp__thumb', sec);
    var countEl = $('[data-count-current]', sec);
    var idx = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var origLabel = addLabel ? addLabel.textContent : '';

    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === idx); });
      if (countEl) countEl.textContent = (idx + 1 < 10 ? '0' : '') + (idx + 1);
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = $('[data-gallery-prev]', sec), next = $('[data-gallery-next]', sec);
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    function selected() {
      return $$('.opt', sec).map(function (f) { var c = $('input:checked', f); return c ? c.value : null; });
    }
    function findVariant() {
      var sel = selected();
      return product.variants.find(function (v) { return sel.every(function (val, i) { return v.options[i] === val; }); });
    }
    function stateFor(v) {
      if (!v) { addBtn.disabled = true; addLabel.textContent = (T.strings && T.strings.soldOut) || 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? origLabel_ok() : T.strings.soldOut;
      var priceEl = $('[data-price]', sec), cmpEl = $('[data-compare]', sec), tag = $('[data-stock-tag]', sec);
      if (priceEl) priceEl.textContent = money(v.price);
      if (cmpEl) { if (v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false; } else cmpEl.hidden = true; }
      if (tag) { tag.textContent = v.available ? 'In stock' : T.strings.soldOut; tag.classList.toggle('tag--out', !v.available); }
      if (v.featured_media) {
        var i = slides.findIndex(function (s) { return String(s.getAttribute('data-media-id')) === String(v.featured_media.id); });
        if (i > -1) show(i);
      }
      if (history.replaceState) history.replaceState({}, '', product_url() + '?variant=' + v.id);
    }
    function origLabel_ok() { return (origLabel && origLabel !== T.strings.soldOut) ? origLabel : T.strings.addToCart; }
    function product_url() { return sec.getAttribute('data-product-url') || location.pathname; }

    // remember the in-stock label even if the page loaded on a sold-out variant
    if (addBtn && addBtn.disabled) origLabel = T.strings.addToCart;

    $$('.opt', sec).forEach(function (fs) {
      fs.addEventListener('change', function () {
        var lab = $('[data-option-label]', fs), c = $('input:checked', fs);
        if (lab && c) lab.textContent = '/ ' + c.value;
        stateFor(findVariant());
        markUnavailable();
      });
    });
    // strike through option values that have no available variant given the other selections
    function markUnavailable() {
      var sel = selected();
      $$('.opt', sec).forEach(function (fs, oi) {
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[oi] = inp.value;
          var v = product.variants.find(function (x) { return test.every(function (val, i) { return x.options[i] === val; }); });
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    markUnavailable();

    // quantity
    var qty = $('[data-pdp-qty]', sec);
    var minus = $('[data-pdp-minus]', sec), plus = $('[data-pdp-plus]', sec);
    if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, Number(qty.value) - 1); });
    if (plus) plus.addEventListener('click', function () { qty.value = Number(qty.value) + 1; });

    // ajax add to cart
    if (form) form.addEventListener('submit', function (e) {
      if (T.cartType !== 'drawer') return; // normal submit → cart page
      e.preventDefault();
      if (addBtn.disabled) return;
      errEl.hidden = true;
      addBtn.disabled = true;
      var prevText = addLabel.textContent;
      addLabel.textContent = '…';
      fetch(T.routes.cartAdd + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qty.value) || 1 }] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return refreshCart(); })
        .then(function () { addLabel.textContent = T.strings.added; openDrawer(); setTimeout(function () { addLabel.textContent = prevText; addBtn.disabled = false; }, 1400); })
        .catch(function (err) {
          errEl.textContent = (err && (err.description || err.message)) || T.strings.error;
          errEl.hidden = false; addLabel.textContent = prevText; addBtn.disabled = false;
        });
    });
  }

  /* ---------- recommendations (custom element) ---------- */
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url; if (!url || this.dataset.loaded) return;
        this.dataset.loaded = '1';
        var self = this;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var n = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
          if (n && n.innerHTML.trim()) self.innerHTML = n.innerHTML;
          else if (!self.innerHTML.trim()) { var s = self.closest('.section'); if (s) s.hidden = true; }
        }).catch(function () {});
      }
    });
  }

  /* ---------- collection filters ---------- */
  function initFilters() {
    var f = $('[data-filter-form]'); if (!f) return;
    f.addEventListener('change', function () { f.submit(); });
    document.addEventListener('click', function (e) {
      $$('.fdrop[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    if (!document.body.classList.contains('has-anim') || !('IntersectionObserver' in window)) {
      $$('.section,.editorial,.cta').forEach(function (el) { el.classList.add('is-in'); }); return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.section,.editorial,.cta').forEach(function (el) { io.observe(el); });
  }


  /* ---------- New drop hero motion ---------- */
  function initHeroMotion() {
    var heroes = $$('[data-hero-motion]');
    if (!heroes.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    heroes.forEach(function (hero) {
      var stage = $('[data-hero-stage]', hero);
      var layers = $$('[data-hero-layer]', hero);
      if (!stage || reduce || !window.matchMedia('(pointer:fine)').matches) return;
      var raf = null, mx = 0, my = 0;
      function paint() {
        raf = null;
        layers.forEach(function (layer) {
          var depth = Number(layer.getAttribute('data-hero-layer') || 0) + 1;
          var x = mx * depth * 7;
          var y = my * depth * 5;
          layer.style.setProperty('--hero-parallax-x', x.toFixed(2) + 'px');
          layer.style.setProperty('--hero-parallax-y', y.toFixed(2) + 'px');
          layer.style.translate = x.toFixed(2) + 'px ' + y.toFixed(2) + 'px';
        });
      }
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - .5;
        my = (e.clientY - r.top) / r.height - .5;
        if (!raf) raf = requestAnimationFrame(paint);
      }, { passive: true });
      stage.addEventListener('pointerleave', function () {
        mx = 0; my = 0;
        if (!raf) raf = requestAnimationFrame(paint);
      }, { passive: true });
    });
  }

  /* ---------- Syffer motion: welcome preloader + header ---------- */
  function initSyfferMotion() {
    var loader = $('#SyfferPreloader');
    var header = $('.site-header');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (loader) {
      var alreadySeen = document.documentElement.classList.contains('syffer-preloader-skip');
      if (alreadySeen || reduce) {
        loader.classList.add('is-loaded');
      } else {
        var hideLoader = function () {
          setTimeout(function () { loader.classList.add('is-loaded'); }, 2400);
        };
        if (document.readyState === 'complete') hideLoader();
        else window.addEventListener('load', hideLoader, { once: true });
      }
    }

    if (header) {
      var updateHeader = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
    }
  }

  function init() {
    initSyfferMotion(); initHeroMotion(); initHeader(); initCart(); initFilters(); initReveal();
    $$('[data-product-section]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-section]', e.target).forEach(initProduct);
    $$('.section,.editorial,.cta', e.target).forEach(function (el) { el.classList.add('is-in'); });
  });
})();
